import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=7f89f26e&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./Settings.vue?vue&type=style&index=1&id=7f89f26e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f89f26e",
  null
  
)

export default component.exports